import { render } from "./ResumeSectionExtendedTrips.vue?vue&type=template&id=b553203c"
import script from "./ResumeSectionExtendedTrips.vue?vue&type=script&lang=js"
export * from "./ResumeSectionExtendedTrips.vue?vue&type=script&lang=js"

import "./ResumeSectionExtendedTrips.vue?vue&type=style&index=0&id=b553203c&lang=css"
script.render = render

export default script